export const STORE_REQUEST_METADATA = 'STORE_REQUEST_METADATA';
export const STORE_REQUEST_ORIGIN = 'STORE_REQUEST_ORIGIN';

export function storeRequestOrigin(request) {
  return {
    type: STORE_REQUEST_ORIGIN,
    origin: `https://${request.get('host')}`,
  };
}

export function storeRequestMetadata(request) {
  // orginalUrl it passed from http module to Express.js
  const urlString = request.originalUrl.toLowerCase();
  const referrer = request.get('referer');
  const referrerString = referrer && referrer.includes('https://') ? `${referrer}` : '';
  return {
    type: STORE_REQUEST_METADATA,
    referrer: referrerString,
    origin: `https://${request.get('host')}`,
    currentRoute: urlString,
    previousRoute: '',
    query: request.query || {},
  };
}

export function storeRequestMetadataClient(metaData) {
  return {
    type: STORE_REQUEST_METADATA,
    referrer: metaData.referrer,
    origin: metaData.origin,
    currentRoute: metaData.currentRoute,
    previousRoute: metaData.previousRoute,
    query: metaData.query || {},
  };
}
